import { API_PATH_ECOM_POLICY_GREENPOOL_ORDER, API_PATH_MASTER_ORDERS } from '@/api/apiRoutes'
import { post } from '@/util/auth'

export type MasterOrderLineRequest = {
  productCatalogueId: number
  quantity: number
  policyId: number
}

export type MasterOrderAssetRequest = {
  assetId: number
  policyId: number
  decision: 'BUYOUT' | 'RETURN' | 'NONE'
}

export type MasterOrderRequest = {
  idempotencyKey: string
  userId?: number
  deliveryAddress: string
  city: string
  zip: string
  countryId?: number
  addressId?: number
  numberOfDownPayments?: number
  isPrivateAddress?: boolean
  orderLines: MasterOrderLineRequest[]
  assets: MasterOrderAssetRequest[]
}
type AvailableAsset = { id: number; is_buyout: boolean }
export type GreenpoolOrderPayload = {
  policyId: number
  orderPayload: {
    assetId: number
    assets?: AvailableAsset[]
  }
  isMasterOrder?: boolean
}
export const ecomPolicyOrdersResources = {
  // Mutation
  createMasterOrder: async (data: MasterOrderRequest) => {
    const response = await post(API_PATH_MASTER_ORDERS, data)
    return response
  },
  createGreenpoolOrder: async ({
    policyId,
    orderPayload,
    isMasterOrder = false,
  }: GreenpoolOrderPayload): Promise<{ orderId: number; isMasterOrder: boolean }> => {
    const response = await post(
      API_PATH_ECOM_POLICY_GREENPOOL_ORDER.replace(':policyId', String(policyId)),
      orderPayload
    )

    return { orderId: response, isMasterOrder }
  },
}
